"use strict";

import http from "@/http";
import moment from "moment";
import store from "@/store/store";
import constants from "@/store/modules/constants";

const BASE_NAME = "/contractor";

const list = async () => {
  const response = await http.get(`${BASE_NAME}`);
  return response.data;
};

const getById = async id => {
  const response = await http.get(`${BASE_NAME}/${id}`);
  return response.data;
};

const create = async data => {
  const response = await http.post(`${BASE_NAME}`, data);
  return response.data;
};

const edit = async contractor => {
  const response = await http.put(`${BASE_NAME}/${contractor._id}`, contractor);
  return response.data;
};

const remove = async id => {
  const response = await http.delete(`${BASE_NAME}/${id}`);
  return response.data;
};

const isValidId = async (id, number) => {
  const response = await http.get(`${BASE_NAME}/${id}/is-valid-id/${number}`);
  return response.data;
};

const isValidEmployeeId = async (id, eid, number) => {
  const response = await http.get(
    `${BASE_NAME}/${id}/employees/${eid}/is-valid-id/${number}`
  );
  return response.data;
};

const lookupIdentifers = async () => {
  const response = await http.get("/lookup-values/identifications");
  return response.data;
};

const search = async filters => {
  const response = await http.post(`${BASE_NAME}/search`, { filters: filters });
  return response.data;
};

const isInvalidObligation = obligation => {
  return (
    [
      store.state.constants.OBLIGATIONS.STATUS.DELAYED,
      store.state.constants.OBLIGATIONS.STATUS.MISSING_DATE
    ].indexOf(obligation.status) != -1
  );
};

const countInvalidObligations = obligations => {
  let count = 0;
  obligations.forEach(obligation => {
    count += !isInvalidObligation(obligation) ? 1 : 0;
  });
  return count;
};

const getFirstInvalidMessage = obligation => {
  if (!obligation.delivered) {
    return store.state.locale.resx.messages.notDelivered;
  }

  if (
    obligation.dueDateType == "date_limit" &&
    moment(obligation.dueDate).isBefore(moment())
  ) {
    return store.state.locale.resx.messages.dueDated;
  }
};

const getObligations = async (id, type, object) => {
  let url;
  if (type == constants.state.OBLIGATIONS.TYPES.VEHICLE_OBLIGATION) {
    url = `${BASE_NAME}/${id}/obligations?type=${type}&vehicle_id=${object.id}&vehicle_type=${object.typeId}`;
  } else if (type == constants.state.OBLIGATIONS.TYPES.EMPLOYEES_OBLIGATION) {
    url = `${BASE_NAME}/${id}/obligations?type=${type}&employee_id=${object.id}`;
  } else {
    url = `${BASE_NAME}/${id}/obligations?type=${type}`;
  }
  const response = await http.get(url);
  return response.data;
};

const addObligation = async (id, obligation) => {
  const response = await http.post(
    `${BASE_NAME}/${id}/obligations`,
    obligation
  );
  return response.data;
};

const editObligation = async (id, obligation) => {
  const response = await http.put(
    `${BASE_NAME}/${id}/obligations/${obligation._id}`,
    obligation
  );
  return response.data;
};

const deleteObligation = async (id, obligation) => {
  const response = await http.delete(
    `${BASE_NAME}/${id}/obligations/${obligation._id}`
  );
  return response.data;
};

const obligationAuth = async (id, oid, action) => {
  const response = await http.put(
    `${BASE_NAME}/${id}/obligations/${oid}/authorization`,
    { action }
  );
  return response.data;
};

const getVehicles = async (id, vehicle) => {
  const response = await http.get(`${BASE_NAME}/${id}/vehicles`, vehicle);
  return response.data;
};

const addVehicle = async (id, vehicle) => {
  const response = await http.post(`${BASE_NAME}/${id}/vehicles`, vehicle);
  return response.data;
};

const editVehicle = async (id, vehicle) => {
  const response = await http.put(
    `${BASE_NAME}/${id}/vehicles/${vehicle._id}`,
    vehicle
  );
  return response.data;
};

const deleteVehicle = async (id, vehicle) => {
  const response = await http.delete(
    `${BASE_NAME}/${id}/vehicles/${vehicle._id}`
  );
  return response.data;
};

const addVisit = async id => {
  const response = await http.post(`${BASE_NAME}/${id}/visit`);
  return response.data;
};

const haveVisitToday = async id => {
  const response = await http.get(`${BASE_NAME}/${id}/visit/today`);
  return !response.data;
};

const rateContractor = async (
  contractorId,
  visitId,
  rate,
  comment,
  motive,
  dateOfVisit,
  endOfVisit,
  duration
) => {
  const response = await http.put(
    `${BASE_NAME}/${contractorId}/visit/${visitId}/rate`,
    { rate, comment, motive, dateOfVisit, endOfVisit, duration }
  );
  return response.data;
};

const getHistory = async contractorId => {
  const response = await http.get(`${BASE_NAME}/${contractorId}/history`);
  return response.data;
};

const isValidEmail = async (contractorId, email) => {
  const response = await http.get(
    `${BASE_NAME}/${contractorId}/is-valid-email/${email}`
  );
  return response.data;
};

const createEmployee = async (contractorId, employee) => {
  const response = await http.post(
    `${BASE_NAME}/${contractorId}/employees`,
    employee
  );
  return response.data;
};

const editEmployee = async (contractorId, employee) => {
  const response = await http.put(
    `${BASE_NAME}/${contractorId}/employees/${employee._id}`,
    employee
  );
  return response.data;
};

const deleteEmployee = async (contractorId, employeeId) => {
  const response = await http.delete(
    `${BASE_NAME}/${contractorId}/employees/${employeeId}`
  );
  return response.data;
};

export default {
  list,
  search,
  getById,
  create,
  edit,
  remove,
  isValidId,
  isValidEmployeeId,
  lookupIdentifers,
  isInvalidObligation,
  countInvalidObligations,
  getFirstInvalidMessage,
  rateContractor,
  isValidEmail,

  // Obligations
  getObligations,
  addObligation,
  editObligation,
  deleteObligation,
  obligationAuth,

  // Vehicles
  getVehicles,
  addVehicle,
  editVehicle,
  deleteVehicle,

  //visits
  addVisit,
  haveVisitToday,
  getHistory,

  // Employees
  createEmployee,
  editEmployee,
  deleteEmployee
};
